<template>
  <b-container fluid>
    <b-row>
      <b-col md="12">
        <iq-card body-class="p-0">
          <template v-slot:body>
            <div class="iq-edit-list">
              <tab-nav :pills="true" class="iq-edit-profile d-flex">
                <tab-nav-items
                  class="col-md-4 p-0"
                  :active="true"
                  title="REQUEST & PROGRESS"
                  @click=";(selectedTab = 'progress'), fetchData()"
                />
                <tab-nav-items
                  class="col-md-4 p-0"
                  :active="false"
                  title="FINISH REPAIR & MAINTENANCE"
                  @click=";(selectedTab = 'finish'), fetchData()"
                />
                <tab-nav-items
                  class="col-md-4 p-0"
                  :active="false"
                  @click="selectedTab = 'report'"
                  title="REPORT REPAIR & MAINTENANCE"
                />
              </tab-nav>
            </div>
          </template>
        </iq-card>
      </b-col>
      <b-col col="12" v-if="selectedTab == 'report'">
        <NewTabReport
          :fleetOptions="optionsFleets"
          :fleetTypeOptions="optionsVehicleType"
          :statusOptions="statusOptions"
          :defaultParams="params"
        />
      </b-col>
      <b-col md="12" v-else>
        <iq-card>
          <template #headerTitle>
            <h5 class="card-title text-primary">
              <strong> SERVICE & REPAIR</strong>
            </h5>
          </template>
          <template #headerAction>
            <b-button
              v-if="selectedTab == 'progress' && getSrAcces('add')"
              variant="primary"
              @click="showModalFleets = true"
              >Create Data</b-button
            >
          </template>
          <template #body>
            <div class="w-100">
              <b-row>
                <b-col md="12">
                  <div class="d-flex justify-content-end">
                    <!-- <b-button
                        v-if="selectedTab == 'progress' && getSrAcces('export')"
                        variant="outline-primary"
                        class="mr-2"
                        >Import</b-button
                      >
                      <b-button
                        v-if="getSrAcces('export')"
                        variant="outline-primary"
                        class="mr-2"
                        >Export</b-button
                      > -->
                  </div>
                </b-col>
                <b-col md="12" class="my-3">
                  <SrFiltersTemplate
                    :statusOptions="statusOptions"
                    :optionsFleets="optionsFleets"
                    :optionsVehicleType="optionsVehicleType"
                    :params="params"
                    @onFilter="fetchData"
                    v-model="params"
                  />
                </b-col>
                <b-col md="12">
                  <table class="w-100 table-striped">
                    <thead>
                      <th>Vessel Name</th>
                      <th>Loaction</th>
                      <th>Accident Date</th>
                      <th v-if="selectedTab == 'finish'">Actual Finish Date</th>
                      <th v-if="selectedTab == 'finish'">Total Days</th>
                      <th>Total Item Repair</th>
                      <th v-if="selectedTab == 'progress'"
                        >Est. Cost Service & Repair</th
                      >
                      <th>Pic</th>
                      <th v-if="selectedTab == 'progress'">Status</th>
                      <th v-if="selectedTab == 'progress'">Work Location</th>
                      <th>Action</th>
                    </thead>
                    <tbody v-if="!loading">
                      <template v-if="listServiceRepair.length">
                        <tr
                          v-for="(item, index) in listServiceRepair"
                          :key="index"
                        >
                          <td>
                            <b-badge
                              v-if="selectedTab != 'finish'"
                              variant="success"
                              >{{ item.fleet }}</b-badge
                            >
                            <b-badge v-else variant="success">{{
                              item.vehicle.name
                            }}</b-badge>
                          </td>
                          <td>{{ item.location }}</td>
                          <td>{{ toFormatDate(item.accident_at) }}</td>
                          <td v-if="selectedTab == 'finish'">{{
                            item?.finish_date_real
                              ? toFormatDate(item?.finish_date_real)
                              : '-'
                          }}</td>
                          <td v-if="selectedTab == 'finish'">
                            <template
                              v-if="
                                item.start_date_est && item.finish_date_real
                              "
                            >
                              {{
                                totalDays(
                                  item.start_date_est,
                                  item.finish_date_real
                                )
                              }}
                              Days
                            </template>
                            <template v-else>-</template>
                          </td>
                          <td>{{ item.total_repair }} Repair</td>
                          <td v-if="selectedTab == 'progress'">{{
                            formatCurrency(item.cost_est ?? 0)
                          }}</td>
                          <td class="d-flex flex-column">
                            <p class="mb-0">{{ item.pic }}</p>
                          </td>
                          <td v-if="selectedTab == 'progress'">
                            <b-badge
                              :variant="`${
                                item?.status === 'new'
                                  ? 'info'
                                  : item.status === 'review'
                                  ? 'primary'
                                  : item.status === 'approved'
                                  ? 'success'
                                  : item.status === 'progress'
                                  ? 'warning'
                                  : 'danger'
                              } d-block`"
                              >{{ item?.status }}</b-badge
                            >
                          </td>
                          <td v-if="selectedTab == 'progress'">{{
                            item.site ?? '-'
                          }}</td>
                          <td>
                            <b-dropdown
                              text="Action"
                              size="sm"
                              variant="outline-primary"
                            >
                              <b-dropdown-item
                                v-if="
                                  item.status == 'review' &&
                                  getSrAcces('approval')
                                "
                                @click="() => handleAction(item, 'approve')"
                                >Approve Service & Repair</b-dropdown-item
                              >
                              <b-dropdown-item
                                v-if="
                                  item.status == 'new' && getSrAcces('update')
                                "
                                @click="() => handleAction(item, 'review')"
                                >Review Service & Repair</b-dropdown-item
                              >
                              <b-dropdown-item
                                @click="() => handleAction(item, 'detail')"
                                >Detail Service & Repair</b-dropdown-item
                              >
                              <b-dropdown-item
                                v-if="selectedTab == 'finish'"
                                @click="() => handleAction(item, 'history')"
                                >History Service & Repair</b-dropdown-item
                              >
                              <!-- <b-dropdown-item v-if="
                                selectedTab == 'progress' &&
                                item.status == 'new'
                              " @click="() => handleAction(item, 'update')">Update Service & Repair</b-dropdown-item> -->
                              <b-dropdown-item
                                v-if="
                                  selectedTab == 'finish' &&
                                  !item?.finish_date_real &&
                                  !item?.start_date_real &&
                                  getSrAcces('update')
                                "
                                @click="() => handleAction(item, 'finish')"
                                >Set Realization Service &
                                Repair</b-dropdown-item
                              >
                              <b-dropdown-item
                                v-if="
                                  selectedTab == 'progress' &&
                                  !permissionDelete(item?.request_delete)
                                "
                                @click="
                                  () => onRequestDeleteServiceRepair(item)
                                "
                                >Request Delete Service &
                                Repair</b-dropdown-item
                              >
                              <b-dropdown-item
                                v-if="
                                  selectedTab == 'progress' &&
                                  permissionDelete(item?.request_delete)
                                "
                                @click="() => deleteServiceRepair(item)"
                                >Delete Service & Repair</b-dropdown-item
                              >
                              <b-dropdown-item
                                @click="
                                  ;(showSidebar = true), (selectedItem = item)
                                "
                                >Log History</b-dropdown-item
                              >
                            </b-dropdown>
                          </td>
                        </tr>
                      </template>
                      <template v-else>
                        <tr>
                          <td class="p-2" colspan="9">
                            No Data Service & Repair
                          </td>
                        </tr>
                      </template>
                    </tbody>
                  </table>
                  <div
                    v-if="loading"
                    class="w-100 d-flex justify-content-center py-5"
                  >
                    <b-spinner></b-spinner>
                  </div>
                </b-col>
              </b-row>
              <div class="mt-4 d-flex align-items-center w-100 justify-content-end">
                <b-pagination class="mb-0 mr-3" @change="(page) => {
                  meta.page = page;
                }" v-model="meta.page" :total-rows="meta.totalItems" :per-page="meta.perPage" first-number
                  align="center"></b-pagination>
                <b-form-select plain v-model="meta.perPage" :options="limitOptions" style="width: 140px;"
                  @input="fetchData"></b-form-select>
              </div>
            </div>
          </template>
        </iq-card>
      </b-col>
      <modal-fleets
        :isOpen="showModalFleets"
        @close="showModalFleets = false"
        @next="
          (vehicleId) =>
            $router.push('/sr/service-repair-form?vehicleId=' + vehicleId)
        "
      />
      <b-sidebar
        v-model="showSidebar"
        title="Log History Service & Repair"
        right
        width="540px"
        bg-variant="white"
        shadow
        backdrop
      >
        <template v-if="showSidebar">
          <LogsHistoryItemSR
            :selectedItem="selectedItem"
            :defaultParams="defaultParams"
          />
        </template>
      </b-sidebar>
    </b-row>
  </b-container>
</template>
<script>
import moment from '@/node_modules/moment/moment'
import { crewingActions, fleetsActions, srActions } from '@/src/Utils/helper'
import FilterGroup from '@/src/components/global/FilterGroup.vue'
import ModalFleets from './components/ModalFleets.vue'
import LogsHistoryItemSR from './components/LogsHistoryItemSR.vue'
import TabReport from './TabReport.vue'
import NewTabReport from './components/NewTabReport.vue'
import { limitOptions } from '@/src/core/mock/data/optionsData'
import { getAccessPermission } from '@/src/plugins/helpers'
import SrFiltersTemplate from './components/SrFiltersTemplate.vue'

export default {
  name: 'ServiceRepairList',
  components: {
    FilterGroup,
    ModalFleets,
    LogsHistoryItemSR,
    TabReport,
    NewTabReport,
    SrFiltersTemplate,
  },
  data() {
    return {
      limitOptions,
      selectedItem: null,
      selectedTab: 'progress',
      showModalFleets: false,
      showSidebar: false,
      loading: false,
      params: {
        fleet_id: [],
        fleet_category: [],
        status: [],
        dateRange: [],
      },
      statusOptions: [
        { label: 'New', value: 'new' },
        { label: 'Review', value: 'review' },
        { label: 'Approve', value: 'approve' },
        { label: 'Progress', value: 'progress' },
      ],
      defaultParams: {
        user_id: JSON.parse(localStorage.getItem('profile')).id,
      },
      meta: {
        page: 1,
        perPage: 10,
        totalItems: 10,
        totalPage: 1,
      },
      listServiceRepair: [],
      optionsVehicleType: [],
      optionsFleets: [],
      filters: [
        {
          label: 'Vessel Name',
          selected: [],
          field: 'fleet_id',
          options: [],
          collapse: false,
        },
        {
          label: 'Vessel Type',
          name: 'Vessel Type',
          selected: [],
          field: 'fleet_category',
          options: [],
          collapse: false,
        },
        {
          label: 'Status',
          selected: [],
          field: 'status',
          options: [
            { text: 'New', value: 'new' },
            { text: 'Review', value: 'review' },
          ],
          collapse: false,
        },
      ],
      showModalFilter: false,
    }
  },
  watch: {
    'meta.page': {
      handler (value) {
        if (value) {
          this.fetchData()
        }
      }
    },
    'meta.perPage': {
      handler (value) {
        this.meta.page = 1
      }
    }
  },
  methods: {
    ...srActions,
    ...fleetsActions,
    ...crewingActions,
    async fetchData() {
      try {
        this.loading = true
        const params = {
          user_id: JSON.parse(localStorage.getItem('profile')).id,
          start_date: moment(this.params.dateRange[0]).format('YYYY-MM-DD'),
          end_date: moment(this.params.dateRange[1]).format('YYYY-MM-DD'),
          fleet_id: this.params.fleet_id.map((val) => val.value).toString(),
          fleet_category: this.params.fleet_category
            .map((val) => val.value)
            .toString(),
          status: this.params.status.map((val) => val.value).toString(),
          ...this.meta,
        }

        if (!params.status) delete params.status
        if (!params.fleet_id) delete params.fleet_id
        if (!params?.fleet_category) delete params.fleet_category
        // if (this.selectedTab !== 'progress') delete params.status
        const filterApi =
          this.selectedTab == 'progress'
            ? this.fetchListTableServiceAndRepair(params)
            : this.fetchListTableFinishedServiceAndRepair(params)
        const { data } = await filterApi
        this.meta.totalItems = data.meta.total_item
        this.meta.perPage = data.meta.per_page
        this.meta.totalPage = data.meta.total_pages
        this.listServiceRepair = data.data
        this.loading = false
      } catch (error) {
        this.loading = false
      }
    },
    toFormatDate(val) {
      const formateDate = moment(val).format('DD MMM YYYY')
      return formateDate
    },
    totalDays(startDate, endDate) {
      return moment(endDate).diff(moment(startDate), 'days')
    },
    async fetchFleets() {
      const params = {
        page: 1,
        limit: 999,
        showAll: true,
        ...this.defaultParams,
      }
      let res = await this.getFleets(params)
      if (!res.status) {
        this.optionsFleets = []
      } else {
        this.optionsFleets = res.data.map((val) => ({
          label: val.name,
          value: val.id,
        }))
      }
    },
    async getListVehicleType() {
      try {
        const params = {
          user_id: JSON.parse(localStorage.getItem('profile')).id,
        }
        let res = await this.fetchListVehicleType(params)
        if (res.status === 'error') {
          this.optionsVehicleType = []
        } else {
          this.optionsVehicleType = res.data.data.map((val) => ({
            label: val.name,
            value: val.id,
          }))
          // const idx = this.filters.findIndex(
          //   (el) => el.field == 'fleet_category'
          // )
          // this.filters[idx].options = this.optionsVehicleType
        }
      } catch (error) {
        console.log(error)
      }
    },
    findFilterSelected(field) {
      const finded = this.filters.find((el) => el.field == field)?.selected
      return `${finded}`
    },
    handleAction(item, type) {
      let url = `/sr/service-repair-form?vehicleId=${
        item.fleet_id ?? item.vehicle.id
      }&formId=${item.id}`
      if (type == 'detail') {
        url += '&detail=true'
      } else if (type == 'review') {
        url += '&detail=true&review=true'
      } else if (type == 'finish') {
        url += '&finish=true'
      } else if (type == 'approve') {
        url += '&detail=true&approve=true'
      } else if (type == 'history') {
        this.$router.push(
          `/sr/history-new?vehicleId=${item.fleet_id ?? item.vehicle.id}`
        )
        return false
      }
      this.$router.push(url)
    },
    async onRequestDeleteServiceRepair(srData) {
      this.$swal({
        title: `Are you sure want to request to delete ${srData?.fleet} R&M?`,
        text: "Yes, i'm sure.",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, request it!',
      }).then(async (result) => {
        if (result.isConfirmed) {
          const res = await this.requestDeleteSr({
            id: srData.id,
            params: this.defaultParams,
          })
          if (
            res.status === false ||
            res.status === 400 ||
            res.status === 500
          ) {
            this.$swal('Failed!', 'Something went wrong.', 'error')
            return
          }
          this.fetchData()
          this.$swal('Success!', 'Success delete r&m.', 'success')
        }
      })
    },
    async deleteServiceRepair(srData) {
      this.$swal({
        title: `Are you sure want to delete ${srData?.fleet} R&M?`,
        text: "Yes, i'm sure.",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!',
      }).then(async (result) => {
        if (result.isConfirmed) {
          const res = await this.deleteService({
            id: srData.id,
            params: this.defaultParams,
          })
          if (
            res.status === false ||
            res.status === 400 ||
            res.status === 500
          ) {
            this.$swal('Failed!', 'Something went wrong.', 'error')
            return
          }
          this.fetchData()
          this.$swal('Success!', 'Success delete r&m.', 'success')
        }
      })
    },
    permissionDelete(permitted) {
      let hasAccess = JSON.parse(localStorage.getItem('profile'))
        .menu.find((obj) => obj.menu === 'Apps')
        .child.find((obj) => obj.menu === 'Technical')
        .child.find((obj) => obj.menu === 'Service Repair')?.delete

      if (hasAccess && permitted) {
        return true
      } else {
        return false
      }
    },
    formatCurrency(value) {
      return new Intl.NumberFormat('id-ID', {
        style: 'currency',
        currency: 'IDR',
      }).format(value)
    },
    getSrAcces(accessType) {
      return getAccessPermission('Service Repair', accessType)
    },
  },
  computed: {
    defaultRange() {
      const currentDate = new Date()
      const nextDay = new Date(currentDate)
      nextDay.setDate(currentDate.getDate() + 1)
      // Get the last date of the current month
      let lastDateOfMonth = moment().endOf('month')
      lastDateOfMonth = new Date(lastDateOfMonth)
      // Format it to show only the date
      const firstMonthOfTheYear = new Date(currentDate.getFullYear(), 0, 1)
      return [firstMonthOfTheYear, lastDateOfMonth]
    },
  },
  mounted() {
    this.params.dateRange = this.defaultRange
    this.fetchFleets()
    this.getListVehicleType()
    this.fetchData()
  },
}
</script>
<style scoped>
table th {
  padding: 8px;
}

table td {
  padding: 8px;
  color: black;
}

.text-sm {
  font-size: 12px;
}

.text-md {
  font-size: 14px;
}
</style>
